import { frontalQuad, horizontalQuad } from '../geometry';
import type { Camera } from '../geometry';
import type { SceneRegion } from './types';

/**
 * Kitchen countertop — a close, slightly raised view across a counter run: counter top and edge,
 * a full-height stone backsplash, a window above the sink. Metres; the camera stands 1.9 m in front of
 * the counter edge at eye height 1.7 m with a shifted lens (verticals stay vertical).
 */
export const kitchenCamera: Camera = { eye: [0, 1.7, -1.9], focal: 900, center: [600, 250] };

export const KITCHEN = {
  /** Counter edge (near) and back wall depths. */
  zFront: 0,
  zWall: 0.65,
  counterY: 0.92,
  edge: 0.04,
  /** Where the backsplash stops and the upper cabinets / window frame begin. */
  splashTop: 1.56,
  /** Half width of the surfaces: wider than the frame so the cropped ends are never visible. */
  half: 1.85,
} as const;

const { zFront, zWall, counterY, edge, splashTop, half } = KITCHEN;

/** Painter's order, far to near: backsplash → counter top → counter edge. */
export const kitchenRegions: readonly SceneRegion[] = [
  {
    id: 'splash',
    quad: frontalQuad(kitchenCamera, -half, half, counterY, splashTop, zWall),
    size: [2 * half, splashTop - counterY],
    tile: 0.95,
    bleed: 1.2,
  },
  {
    id: 'top',
    quad: horizontalQuad(kitchenCamera, -half, half, zFront, zWall, counterY),
    size: [2 * half, zWall - zFront],
    tile: 0.95,
    bleed: 1,
  },
  {
    id: 'edge',
    quad: frontalQuad(kitchenCamera, -half, half, counterY - edge, counterY, zFront),
    size: [2 * half, edge],
    tile: 0.95,
    bleed: 0.6,
  },
];
